module.exports = __webpack_public_path__ + "img/2.aa1d14d6.jpg";